import type { VFC } from 'react';

export const EmptyCell: VFC = () => <> - </>;
